import React from 'react'
import { useHistory  } from 'react-router-dom';
const Ideltimeout = () => {
  const history = useHistory();
  const goSignin = () => {
    history.push("/login");
  }
    return (
      <div className="authincation h-100">
        <div className="container h-100">
          <div className="row col-auto">
            {"        "}
  
          </div>
          <div className="row justify-content-center h-100 align-items-center">
            <div className="col-md-7">
              <div className="form-input-content text-center error-page">
                
                <h4>
                  <i className="fa fa-exclamation-triangle text-warning" />
                  You Have Been Idle!
                </h4>
                <p>
                Your session is Timed Out !
                </p>
                <div>
                  <button className="btn btn-primary"  onClick={goSignin}>
                    Sign In 
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  export default Ideltimeout;
  